import { useEffect, useState } from "react";
import { apiGet, apiPost } from "../api/api";

export default function UsersList() {

  // 🔥 Hooks sempre no topo
  const [users, setUsers] = useState([]);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const role = localStorage.getItem("role");

  async function load() {
    const data = await apiGet("/users");
    setUsers(data);
  }

  useEffect(() => {
    if (role === "admin") {
      load();
    }
  }, [role]);

  async function criar() {
    if (!email || !password) return alert("Preencha email e password");

    await apiPost("/users", { email, password });
    setEmail("");
    setPassword("");
    load();
  }

  async function apagar(id) {
    await fetch("/api/users/" + id, {
      method: "DELETE",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    });

    load();
  }

  // 🔐 Se não for admin → mostra mensagem
  if (role !== "admin") {
    return (
      <div style={{ padding: 20 }}>
        <h2>Gestão de Utilizadores</h2>
        <p style={{ color: "red" }}>Acesso não autorizado</p>
      </div>
    );
  }

  // 🔓 Se for admin → mostra a gestão completa
  return (
    <div style={{ padding: 20 }}>
      <h2>Gestão de Utilizadores</h2>

      <div style={{ marginBottom: 20 }}>
        <h3>Criar Utilizador</h3>

        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={e => setEmail(e.target.value)}
        />

        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={e => setPassword(e.target.value)}
        />

        <button onClick={criar}>Criar</button>
      </div>

      <table border="1" cellPadding="10">
        <thead>
          <tr>
            <th>ID</th>
            <th>Email</th>
            <th>Role</th>
            <th>Ações</th>
          </tr>
        </thead>

        <tbody>
          {users.map(u => (
            <tr key={u.id}>
              <td>{u.id}</td>
              <td>{u.email}</td>
              <td>{u.role}</td>
              <td>
                <button onClick={() => apagar(u.id)}>Apagar</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
